import React, { useState, useEffect } from 'react';
import {PersistentManager} from "../utils/PersistentManager";
import { trackPageView, trackSettingsChange, trackUserInteraction } from '../utils/analytics';

const Settings: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  const [panSensitivity, setPanSensitivity] = useState(0.25);
  const [playSound, setPlaySound] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Track page view
    trackPageView('Settings', {
      route_path: '/settings'
    });

    // Load saved settings from local storage
    const loadSettings = async () => {
      try {
        const savedPanSensitivity = await PersistentManager.getInstance().getItem('panSensitivity');
        const savedPlaySound = await PersistentManager.getInstance().getItem('playSound');

        if (savedPanSensitivity) {
          setPanSensitivity(parseFloat(savedPanSensitivity));
        }
        if (savedPlaySound) {
          setPlaySound(savedPlaySound === 'true');
        }
        setIsLoading(false);
      } catch (error) {
        console.error('Error loading settings:', error);
        setIsLoading(false);
      }
    };

    loadSettings();
  }, []);

  const handlePanSensitivityChange = (value: number) => {
    setPanSensitivity(value);
    trackSettingsChange('pan_sensitivity', value);
  };

  const handlePlaySoundChange = () => {
    const newValue = !playSound;
    setPlaySound(newValue);
    trackSettingsChange('play_sound', newValue);
  };

  const handleSave = () => {
    trackUserInteraction('settings_save', {
      pan_sensitivity: panSensitivity,
      play_sound: playSound
    });
    
    PersistentManager.getInstance().setItem('panSensitivity', panSensitivity.toString());
    PersistentManager.getInstance().setItem('playSound', playSound.toString());
    onClose(); // Close settings after saving
  };

  const handleClose = () => {
    trackUserInteraction('settings_close', {
      from_page: 'settings'
    });
    onClose();
  };

  if (isLoading) {
    return <div>Loading settings...</div>;
  }

  return (
    <div>
      <h2>Settings</h2>
      <label>
        Pan Sensitivity:
        <input
          type="range"
          min="0.1"
          max="2"
          step="0.1"
          value={panSensitivity}
          onChange={(e) => handlePanSensitivityChange(parseFloat(e.target.value))}
        />
        {panSensitivity}
      </label>
      <label>
        Play Sound:
        <input
          type="checkbox"
          checked={playSound}
          onChange={handlePlaySoundChange}
        />
      </label>
      <button onClick={handleSave}>Save</button>
      <button onClick={handleClose}>Close</button>
    </div>
  );
};

export default Settings;
